var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingyellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27.99,
    height: 27.99,
    rx: 8.75,
    fill: "#FFF3CC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9951 10.4878V13.9853L16.3268 15.1511",
    stroke: "#EAB308",
    strokeWidth: 1.16583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9952 19.8146C17.2145 19.8146 19.8243 17.2048 19.8243 13.9854C19.8243 10.7661 17.2145 8.15625 13.9952 8.15625C10.7758 8.15625 8.16602 10.7661 8.16602 13.9854C8.16602 17.2048 10.7758 19.8146 13.9952 19.8146Z",
    stroke: "#EAB308",
    strokeWidth: 1.16583,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingyellow);
export default __webpack_public_path__ + "static/media/pendingyellow.bb17e268b6a835ed1f644b169336b257.svg";
export { ForwardRef as ReactComponent };